import { Button, PageHeader } from 'components';
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import styles from './style.module.scss';
import { Tabs } from 'antd';
import { useNavigate } from 'hooks/useNavigate';
import UsersRolesPage from './userRoles';
import UsersPremisionsPage from './userPremisions';
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../hooks/useUser';

const { TabPane } = Tabs;

const UsersRolesPages = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  function callback(key) {
    navigate(`/sso/user_roles/page/${key}`);
  }
  let btnLink = 'premisions/create/new';

  if (pathname.includes('page/role')) {
    btnLink = 'role/create/new';
  } else if (pathname.includes('page/notification-groups')) {
    btnLink = 'notification-groups/create/new';
  }
  const hideTabs = pathname.includes('edit-model');
  const hideCreateBtn = pathname.includes('present-notifications');
  useEffect(() => {
    if (
      !pathname.includes('/page/role') &&
      !pathname.includes('/page/premisions') &&
      !pathname.includes('/page/notification-groups') &&
      !pathname.includes('/page/present-notifications')
    ) {
      navigate('/sso/user_roles/page/role');
    }
  }, [pathname]);

  let defaultActiveKey = 'role';

  if (pathname.includes('/page/premisions')) {
    defaultActiveKey = 'premisions';
  }
  const pages = useRecoilValue(getPage);
  return (
    <div>
      {!hideTabs && (
        <PageHeader title={t('Permessi').toUpperCase()}>
          {!hideCreateBtn && pages?.ability?.can_create && (
            <Link to={btnLink}>
              <Button width={'191px'} big icon={<PlusOutlined />}>
                {t('Crea')}
              </Button>
            </Link>
          )}
        </PageHeader>
      )}
      <div className={styles.container}>
        {!hideTabs && (
          <Tabs defaultActiveKey={defaultActiveKey} onChange={callback}>
            <TabPane tab='Ruoli' key='role' />
            <TabPane tab='Preset permessi' key='premisions' />
          </Tabs>
        )}
        <Routes>
          <Route path={'/role/*'} element={<UsersRolesPage />} />
          <Route path={'/premisions/*'} element={<UsersPremisionsPage />} />
        </Routes>
      </div>
    </div>
  );
};

export default UsersRolesPages;
